import { ChipList } from "@/app/library/components/molecules";
import type { Tenant } from "@/app/tenants/utils";
import { Button } from "@/core/ui/atoms";
import {
  AdminMiniList,
  AdminMiniRow,
  AdminPanel,
  AdminStatCard,
  Banner,
} from "@/core/ui/molecules";

type TenantSuccessDialogProps = {
  readonly onClose: () => void;
  readonly onOpenTenant: () => void;
  readonly tenant: Tenant;
};

export function TenantSuccessDialog({
  onClose,
  onOpenTenant,
  tenant,
}: TenantSuccessDialogProps) {
  const packs =
    tenant.vertical === "HVAC"
      ? ["General Service Pack", "HVAC Starter Pack"]
      : ["General Service Pack"];

  return (
    <div className="flex max-h-[calc(100vh-7.5rem)] w-[900px] max-w-[96vw] flex-col overflow-hidden rounded-dialog bg-surface shadow-dialog">
      <header className="flex shrink-0 items-start justify-between gap-4 border-b border-border px-5 py-5">
        <div>
          <h2 className="text-lg font-extrabold text-ink">
            Tenant Created Successfully
          </h2>
          <p className="mt-1 text-[13px] text-ink-muted">
            Tenant, workspace, owner, access presets and template packs were
            created/installed.
          </p>
        </div>
        <button
          className="text-2xl text-ink-subtle"
          onClick={onClose}
          type="button"
        >
          ×
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5">
        <Banner tone="ok">
          <strong>Tenant Created Successfully.</strong> Tenant Setup completed
          without partial state.
        </Banner>
        <div className="mb-3 grid grid-cols-1 gap-3 md:grid-cols-4">
          <AdminStatCard label="Tenant" value="Created" />
          <AdminStatCard label="Workspace" value="Main" />
          <AdminStatCard label="Packs" value={packs.length} />
          <AdminStatCard label="Access Presets" value={2} />
        </div>
        <AdminPanel className="p-[18px]">
          <h3 className="mb-3 text-[15px] font-extrabold text-ink">
            Setup Summary
          </h3>
          <AdminMiniList>
            <AdminMiniRow>
              <strong>Company / Tenant</strong>
              <span>{tenant.name}</span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Plan</strong>
              <span>
                {tenant.plan} · {tenant.vertical}
              </span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Billing</strong>
              <span>{tenant.billing}</span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Owner created</strong>
              <span>{tenant.owner}</span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Invitation sent</strong>
              <span>Yes</span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Initial workspace created</strong>
              <span>Main</span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Template packs installed</strong>
              <ChipList values={packs} />
            </AdminMiniRow>
          </AdminMiniList>
        </AdminPanel>
      </div>
      <footer className="flex shrink-0 justify-end gap-2 border-t border-border bg-panel-muted px-5 py-3.5">
        <Button onClick={onClose}>Create Another Tenant</Button>
        <Button>Copy Client Link</Button>
        <Button onClick={onOpenTenant} variant="primary">
          Open Tenant
        </Button>
      </footer>
    </div>
  );
}
